var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-thread-upload',{attrs:{"required":true,"defaultLabel":"Wiegenote","labelOptions":_vm.labelOptions,"threadId":_vm.thread.id,"publicUpload":false,"form":_vm.form},on:{"new-upload":function($event){return _vm.newUpload()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }